import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { URL } from "../../utils/constants";
import styles from "./styles.module.css";
import { FaRegCopy } from "react-icons/fa";

const HermodoorsCard = () => {
  const { name } = useParams();

  const token = localStorage.getItem("auth_token");
  const authHeader = token ? { authorization: `Token ${token}` } : {};

  const [details, setDetails] = useState(null);

  // ───────── helpers ─────────
  const copyTextToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(String(text ?? ""));
    } catch (err) {
      console.error("copy failed:", err);
    }
  };

  const toHref = (raw = "") => {
    const link = String(raw || "").trim();

    if (!link) return "#";
    if (/^https?:\/\//i.test(link)) return link;
    if (/^file:\/\//i.test(link)) return link;

    if (/^[a-zA-Z]:\\/.test(link)) {
      return "file:///" + link.replace(/\\/g, "/");
    }

    if (/^\\\\/.test(link)) {
      const noLeading = link.replace(/^\\\\/, "");
      return "file://" + noLeading.replace(/\\/g, "/");
    }

    return link;
  };

  // ───────── load hermodoor ─────────
  useEffect(() => {
    if (!name) return;

    fetch(`${URL}/api/hermodoors/${name}/`, {
      method: "GET",
      headers: authHeader,
    })
      .then((response) => response.json())
      .then((data) => {
        setDetails(data);
      })
      .catch((error) => console.error("GET hermodoor error:", error));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name, token]);

  // ───────── grouped archive links ─────────
  const groupedLinks = useMemo(() => {
    const arr = Array.isArray(details?.archive) ? details.archive : [];

    const groups = {
      tDrive: [],
      pDrive: [],
      others: [],
    };

    arr.forEach((element) => {
      const link = String(element?.archive_link || "");

      if (link.startsWith("T:")) {
        groups.tDrive.push(element);
      } else if (link.startsWith("P:")) {
        groups.pDrive.push(element);
      } else {
        groups.others.push(element);
      }
    });

    return groups;
  }, [details]);

  const renderLinks = (links) => (
    <div className={styles.linksList}>
      {links.map((element, index) => {
        const archiveLink = element?.archive_link || "";
        const title = element?.representation_name || archiveLink || "Без названия";

        return (
          <div key={`${archiveLink}-${index}`} className={styles.linkRow}>
            <a
              href={toHref(archiveLink)}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.link}
              title={archiveLink}
            >
              {title}
            </a>

            <button
              type="button"
              className={styles.iconBtn}
              title="Копировать ссылку"
              onClick={() => copyTextToClipboard(archiveLink)}
            >
              <FaRegCopy />
            </button>
          </div>
        );
      })}
    </div>
  );

  if (!details) {
    return (
      <div className={styles.cardPage}>
        <div className={styles.card}>
          <div className={styles.cardScroll}>Загрузка…</div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.cardPage}>
      <div className={styles.card}>
        <div className={styles.cardScroll}>
          <div className={styles.titleRow}>
            <div className={styles.title}>{details.name || "Гермодверь"}</div>

            {(details.lat || details.long) && (
              <button
                type="button"
                className={styles.iconBtn}
                title="Копировать координаты"
                onClick={() => copyTextToClipboard(`${details.lat || ""}, ${details.long || ""}`)}
              >
                <FaRegCopy />
              </button>
            )}
          </div>

          <div className={styles.panel}>
            <div className={styles.infoList}>
              <div className={styles.infoRow}>
                <span className={styles.infoLabel}>Название</span>
                <span className={styles.infoValue}>{details.name || "—"}</span>
              </div>

              <div className={styles.infoRow}>
                <span className={styles.infoLabel}>Линия</span>
                <span className={styles.infoValue}>{details.line || "—"}</span>
              </div>

              <div className={styles.infoRow}>
                <span className={styles.infoLabel}>Координаты</span>
                <span className={styles.infoValue}>
                  {details.lat || "—"} {details.long || ""}
                </span>
              </div>
            </div>
          </div>

          {groupedLinks.tDrive.length > 0 && (
            <div className={styles.panel}>
              <h3 className={styles.h3}>Ссылки на рабочем сервере</h3>
              {renderLinks(groupedLinks.tDrive)}
            </div>
          )}

          {groupedLinks.pDrive.length > 0 && (
            <div className={styles.panel}>
              <h3 className={styles.h3}>Ссылки на удаленном сервере</h3>
              {renderLinks(groupedLinks.pDrive)}
            </div>
          )}

          {groupedLinks.others.length > 0 && (
            <div className={styles.panel}>
              <h3 className={styles.h3}>Другие ссылки</h3>
              {renderLinks(groupedLinks.others)}
            </div>
          )}

          {!groupedLinks.tDrive.length && !groupedLinks.pDrive.length && !groupedLinks.others.length && (
            <div className={styles.panel}>
              <div className={styles.empty}>Архивные ссылки не добавлены</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HermodoorsCard;